import { DateTime } from "luxon";
import { useEffect, useState } from "react";

export const CurrentTimeLine = ({
  startHour = 8,
  endHour = 20,
  hourHeight = 48,
  showTimeLabel = true,
}) => {
  const [currentTime, setCurrentTime] = useState(DateTime.now());

  useEffect(() => {
    // Update immediately on mount
    setCurrentTime(DateTime.now());

    // Update current time every minute
    const timer = setInterval(() => {
      setCurrentTime(DateTime.now());
    }, 60000); // Update every minute

    return () => clearInterval(timer);
  }, []);

  const getCurrentTimePosition = () => {
    const now = DateTime.now();
    const currentHour = now.hour;
    const currentMinutes = now.minute;

    // Check if current time is within the displayed time range
    if (currentHour < startHour || currentHour >= endHour) {
      return null; // Don't show the line if outside of business hours
    }

    // Calculate position from top
    const hoursFromStart = currentHour - startHour;
    const minutesFraction = currentMinutes / 60;
    const topPosition = (hoursFromStart + minutesFraction) * hourHeight;
    return topPosition;
  };

  const formatCurrentTime = () => {
    return currentTime.toFormat("HH:mm");
  };

  const topPosition = getCurrentTimePosition();

  // Don't render if outside business hours
  if (topPosition === null) {
    return null;
  }

  return (
    <div
      className="absolute left-0 right-0 z-40 pointer-events-none"
      style={{ top: `${topPosition}px` }}
    >
      {/* Time label - only show if showTimeLabel is true */}
      {showTimeLabel && (
        <div className="absolute -left-1 -top-3 bg-red-500 text-white text-[10px] px-1.5 py-0.5 rounded font-medium shadow-sm z-20">
          {formatCurrentTime()}
        </div>
      )}

      {/* Red line */}
      <div className="relative">
        {/* Circle at the start */}
        <div className="absolute -left-1 top-1/2 -translate-y-1/2 w-2 h-2 bg-red-500 rounded-full" />

        {/* Horizontal line */}
        <div className="h-0.5 bg-red-500 w-full" />

        {/* Pulsing effect */}
        <div className="absolute inset-0 h-0.5 bg-red-400 animate-pulse" />
      </div>
    </div>
  );
};
